module.exports = "<xo-phone-input-a ng-if=\"!treatment\" token=\"token\" phone=\"phone\"\n                  show-phone-type=\"showPhoneType\" exclude=\"exclude\"></xo-phone-input-a>\n<xo-phone-input-b ng-if=\"treatment\" phone=\"phone\" hide-phone-type=\"showPhoneType === false\"\n                  hide-work=\"hideWork\"></xo-phone-input-b>\n"


//////////////////
// WEBPACK FOOTER
// ./components/xo-form-components/src/phone/phoneInput/template.html
// module id = ./components/xo-form-components/src/phone/phoneInput/template.html
// module chunks = 1